






import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Title from '../../components/Title.vue';
const Manage = namespace('manage');
@Component({
  components: {
    Title,
  },
})
export default class Index extends Vue {
  @Manage.Getter('storeList') private storeList: any;
  @Manage.Action('getStoreList') private getStoreList: any;
  private title: string[] = ['角色权限'];
}
